import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const systemRoutes: CustomRouteRecordRaw = {
  path: 'system',
  name: 'system',
  redirect: { name: 'articleList' },
  component: EmptyLayout,
  meta: {
    title: '系统管理',
    iconfont: 'icon-settings-line',
    requiredPermission: 'system',
  },
  children: [
    {
      path: 'admin-user-list',
      name: 'adminUserList',
      component: () => import('@/views/system/admin-user-list.vue'),
      meta: {
        title: '管理端用户列表',
        requiredPermission: 'system.admin.user.list',
      },
    },
    {
      path: 'admin-department-list',
      name: 'adminDepartmentUserList',
      component: () => import('@/views/system/admin-user-department.vue'),
      meta: {
        title: '管理端部门用户',
        requiredPermission: 'system.admin.user.list',
      },
    },
    {
      path: 'client-menu-list',
      name: 'clientMenuList',
      component: () => import('@/views/system/menu-list.vue'),
      meta: {
        title: '客户端菜单列表',
        requiredPermission: 'system.client.menu.list',
      },
    }
  ],
}
